export enum ElementStates {
  Default = "default", // синий
  Changing = "changing", // розовый
  Modified = "modified", // зеленый
}
